import { createFileRoute, Outlet } from "@tanstack/react-router";
import { PageHeader } from "@/components/app/shell/page-header";
import { guardFeature } from "@/lib/policy/route-guard";
import { KitchenGate } from "./-components/kitchen-gate";
import { MenusTabs } from "./-components/menus-tabs";

/** Menus: the week's calendar, the dishes, the pantry, the ingredient list and what to buy. */
export const Route = createFileRoute("/_authenticated/menus")({
  beforeLoad: ({ context }) => guardFeature(context.me, "menu-planner"),
  head: () => ({
    meta: [
      { title: "Menus | People AI" },
      {
        name: "description",
        content: "The menu calendar, dishes, pantry and shopping list.",
      },
    ],
  }),
  component: MenusLayout,
});

/* Full width beside the rail: a centred column left a third of a wide screen empty and squeezed
 * dishes into two-line chips. The Kitchen agent sits in the right-hand pane beside every page. */
function MenusLayout() {
  return (
    <div className="w-full min-w-0 space-y-5">
      <PageHeader title="Menus" meta="Plan the week, and see what to buy" />
      <KitchenGate>
        <MenusTabs />
        <Outlet />
      </KitchenGate>
    </div>
  );
}
